import { getMessageCreditRecords, getMessageCreditRecord } from 'services/MessageRecordsApiHelper';
import {
  convertCursorToNumber,
  convertNumberToCursor,
  createAction,
  formatNumberWithCommas,
} from '../utils';
import { TimeFormater, formatDate, getDetailPageDisplayLastModifiedDate, getListDisplayLastModifiedDate } from '../utils/TimeFormatUtil';
import { createModel } from './BaseModel';
import { loading } from './LoadingUtil';

function getInitState() {
  return {
    listDisplayFields: [
      { displayName: 'ID', fieldName: 'pk' },
      {
        displayName: 'Message',
        fieldName: 'displayMessageName',
        orderField: 'name',
        linked: true,
        deeplink: (item) => {
          if (item?.message) {
            return `/messages/${item.message.pk}/`
          }
          if (item?.campaign) {
            return `/campaigns/${item.campaign.pk}/`
          }
        }
      },
      {
        displayName: 'Admin',
        fieldName: 'displayMessageAdmin',
        orderField: 'messageAdmin',
      },
      {
        displayName: 'Message create date',
        fieldName: 'displayMessageCreationDate',
        orderField: 'messageCreationDate',
      },
      {
        displayName: 'Credit consumed',
        fieldName: 'displayCreditConsum',
        orderField: 'realCreditSpent',
      },
      {
        displayName: 'Creation time',
        fieldName: 'listDisplayCreationDate',
        orderField: 'creationDate',
      },
    ],
    messageCreditRecordList: [],
  };
}

function parseMessageCreditRecord(item) {
  const message = item?.message
  const recurringMessage = item?.recurringMessage
  let name = "-";
  let displayMessageName = "-";
  let admin = null;
  let messageCreateDate = null
  let realCreditSpent = "0.00"
  let campaign = null;
  if (message) {
    name = message?.name
    displayMessageName = `[${message?.pk}]${message?.name || "-"}`
    admin = message?.admin;
    messageCreateDate = message?.creationDate;
    realCreditSpent = message?.realCreditSpent
  } else if(recurringMessage) {
    campaign = recurringMessage?.campaign;
    name = campaign?.name || "-";
    displayMessageName = campaign ? `[${campaign?.pk}]${campaign?.name || "-"}` : "-"
    admin = recurringMessage?.admin;
    messageCreateDate = recurringMessage?.creationDate;
    realCreditSpent = recurringMessage?.realCreditSpent
  }
  

  return {
    pk: item?.pk || "-",
    message: item?.message,
    recurringMessage: item?.recurringMessage,
    campaign,
    name: item?.message?.name || "-", 
    displayMessageName, 
    admin,
    displayMessageAdmin: admin ? `[${admin?.pk}]${admin?.username || "-"}` : "-",
    messageCreateDate,
    displayMessageCreationDate: formatDate(
      messageCreateDate,
      TimeFormater.dayMonthWeek,
    ),
    creditConsum: realCreditSpent,
    displayCreditConsum: formatNumberWithCommas(realCreditSpent || "") || "0.00", 
    creationDate: item?.creationDate,
    listDisplayCreationDate: getListDisplayLastModifiedDate(
      item?.creationDate,
    ),
    detailDisplayCreationDate: getDetailPageDisplayLastModifiedDate(
      item?.creationDate,
    ),
  };
}

export default createModel({
  namespace: 'messageCreditRecord',
  states: getInitState(),
  params: {
    objectKey: 'messageCreditRecords',
    pkNode: 'MessageCreditRecordNode',
    detailAPI: getMessageCreditRecord,
    parseDetail: (data) => parseMessageCreditRecord(data?.messageCreditRecord),
    initState: getInitState(),
  },
  reducers: {},
  effects: {
    getCurrentPageMessageCreditRecords: [
      function* ({ payload }, { call, put }) {
        const { page } = payload;
        let afterCursor = "";
        if (page > 1) {
          afterCursor = convertNumberToCursor((page - 1) * 20 - 1);
        }
        const serviceArgs = [getMessageCreditRecords, afterCursor, payload];
        function* onSuccess(data) {
          const messageCreditRecordData = data.messageCreditRecords?.edges;
          const pageInfo = data.messageCreditRecords?.pageInfo;
          const totalCount = data.messageCreditRecords.totalCount;
          const startCursor = convertCursorToNumber(pageInfo.startCursor);
          const endCursor = convertCursorToNumber(pageInfo.endCursor);
          const messageCreditRecordDataList = messageCreditRecordData.map((item) =>
            parseMessageCreditRecord(item.node),
          );
          yield put(
            createAction('updateState')({
              pagedList: messageCreditRecordDataList,
              pageInfo: {
                startCursor: isNaN(startCursor) ? 0 : startCursor + 1,
                endCursor: isNaN(endCursor) ? 0 : endCursor + 1,
              },
              totalCount,
              totalPage: Math.ceil(totalCount / 20),
            }),
          );
        }
        yield loading(serviceArgs, onSuccess);
      },
      { type: 'takeLatest' },
    ],
  },
});
